export default {
  edit: {
    title: 'edit',
    type: 'object',
    properties: {
      name: {
        type: 'string',
        minLength: 1,
      },
      shortname: {
        type: 'string',
        minLength: 1,
      },
      active: {
        type: 'boolean',
      },
    },
    required: ['name', 'shortname', 'active'],
  },
};



// WEBPACK FOOTER //
// src/lib/schemas/companies_schemas.js